import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  columnParams,
  columnsParams,
  columnState,
} from '../../models/types/types';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-displayed-columns-menu',
  templateUrl: './displayed-columns-menu.component.html',
  styleUrls: ['./displayed-columns-menu.component.scss'],
})
export class DisplayedColumnsMenuComponent {
  @Input() columnsParams: columnsParams = [];
  @Output() onMooveColumnsOrderEvent = new EventEmitter<
    CdkDragDrop<string[]>
  >();
  @Output() onSelectColumnVisibilityEvent = new EventEmitter<columnState>();

  constructor(private _authSrv: AuthService) {
  }

  get roleFilterdColumn() {
    return this.columnsParams.filter(column => column.role ? column.role === this._authSrv.getDecodedToken().scope : true)
  }

  onMooveColumnsOrder(event: CdkDragDrop<string[]>): void {
    this.onMooveColumnsOrderEvent.next(event);
  }

  onSelectColumnVisibility(columnState: columnState): void {
    this.onSelectColumnVisibilityEvent.next(columnState);
  }
}
